module.exports = __webpack_public_path__ + "static/brenda-headshot.362e2665.jpg";